import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultItemTemplate } from '@/utils/itemDefaultTemplate';

export interface ItemFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; itemJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ItemFormDialog: React.FC<ItemFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; itemJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      itemJson: data.itemJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Item"
      jsonFieldName="itemJson"
      defaultJsonTemplate={defaultItemTemplate()}
      jsonLabel="Enter a valid Item JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Item schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
